import { ImageView, View } from '@play-co/timestep-core/ui';

export default class BaseTeamPage extends View {
  protected header!: ImageView;
  protected contentView!: View;

  constructor(superview: View) {
    super({
      superview,
      width: superview.style.width,
      height: superview.style.height,
    });
    const offsetY = 5;
    const headerHeight = 108;
    this.contentView = new View({
      superview: this,
      width: this.style.width,
      height: this.style.height - headerHeight + offsetY,
      y: headerHeight - offsetY,
    });
    this.header = new ImageView({
      superview: this,
      image: 'assets/ui/match2/team/team_page_header.png',
      width: this.style.width,
      height: headerHeight,
    });
  }

  public refresh() {}
}
